export const ELECTRIC_VEHICLE_FUEL_TYPE_IDS = [4, 9];

export const isElectricFuelType = (
  fuelTypeId?: number | string | null
): boolean => ELECTRIC_VEHICLE_FUEL_TYPE_IDS.includes(Number(fuelTypeId));
